<template>
<div class="card" style="width: 100%">
  <div class="card-body">
    <div class="row">
            <div class="col-md-12 text-center" style="font-size: 18pt;">{{ text }}</div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center" style="font-size: 24pt;">{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value) }}</div>
        </div>
  </div>
</div>
</template>
<script>
export default {
    name: 'FaturamentoCard',
    props: {
        text: {
            type: String,
            required: true,
        },
        value: {
            required: false,
            default: 0.00,
        }
    }
}
</script>